import React from 'react';
import { Link } from 'gatsby';
import HeaderSections from 'src/components/HeaderSections';
import logo from '../../utils/images/hiveon-pool-logo.svg';
import styles from './style.module.css';

const Header = ({ location, siteTitle, activeLink = '' }) => (
  <header className={styles.header}>
    <div className={styles.sectionsContainer}>
      <HeaderSections />
    </div>
    <div className={styles.wrapper}>
      <div className={styles.root}>
        <div className={styles.rootBlock}>
            <Link
              to="/"
              style={{
                color: 'white',
                textDecoration: 'none',
              }}
            >
              <img src={logo} alt="logo"/>
            </Link>
        </div>
      </div>
    </div>
  </header>
)

export default Header
